<template>
  <div id='container-competitor'>
    <div class='row' v-show="searcher">
      <div class='col-sm-4'></div>
      <div class='col-sm-4'>
        <select id="competitor-search">
          <option></option>
        </select>
      </div>
      <div class='col-sm-4'></div>
    </div>
  </div>
</template>

<script>
import $ from "jquery"
let component = null

window.addEventListener("load", function(event) {
  $('body').on('change', '#competitor-search', function(e) {
    var number = $(this).val()
    component.$root.$emit('setCompetitorNumber', number)
  });
});

export default {
  name: "EventSearch",
  props:    {
    eventId: null
  },
  data() {
    return {
      elSearch: '#competitor-search',
      event: null,
      searcher: false,
      competitorNumber: null,
      competitor: {
        type: Object,
        default: null
      }
    }
  },
  created() {
    component = this
    this.$root.$on('setCompetitorNumber', this.setCompetitor)
    this.$root.$on('setEvent', this.setEvent)
  },
  methods:  {
    select2() {
      var $select = $(this.elSearch), url = this.baseUrl;

      $select.select2({
        theme: "bootstrap",
        placeholder: 'Ingrese nombre o número de competidor',
        width: '100%',
        delay: 1500,
        minimumInputLength: 1,
        tag: true,
        ajax: {
          url: url,
          dataType: 'json'
        }
      });
    },
    setEvent(event) {
      const competitor = this.$route.query.competitor
      this.event = event
      this.searcher = event.competitors

      if(this.searcher) {
        if(competitor) {
          this.competitorNumber = competitor
        } else {
          this.$root.$emit('setCompetitor', null)
        }
        this.select2()
      } else {
        this.$root.$emit('setCompetitor', null)
      }
    },
    setCompetitor(number) {
      const path = this.$route.path;
      const url = `${window.location.origin}${path}?competitor=${number}`;
      this.competitorNumber = number;
      history.replaceState({}, "", url);
    },
    getCompetitor() {
      if(this.competitorNumber) {
        this.fetch()
      } else {
        this.$root.$emit('setCompetitor', null)
      }
    },
    async fetch() {
      const response = await this.$http.get(this.competitorUrl)

      if(response && response.status === 200) {
        this.competitor = response.data.competitor
        this.renderCompetitor()
        this.$root.$emit('setCompetitor', this.competitor)
      }
    },
    renderCompetitor() {
      $(this.elSearch).append($('<option>', {
        value: this.competitor.number, text: this.competitor.full_name
      }));
      $(this.elSearch).val(this.competitor.number);
      //$(this.elSearch).trigger('change');
    }
  },
  computed: {
    baseUrl() {
      return `/api/v1/events/${this.event.identifier}/competitors`
    },
    competitorUrl() {
      return `${this.baseUrl}/${this.competitorNumber}`
    }
  },
  watch: {
    competitorNumber(val, oldVal) {
      if(val != oldVal && val) {
        this.$root.$emit('setLoader', true)
        this.getCompetitor()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .mosaic-view {
    .favorites {
      .title {
        font-size: 17px;
        padding-left: 5px;

        img {
          height: 22px;
          vertical-align: text-top;
        }
        i {
          /*color: $app-active-color;*/
          font-size: 19px;
        }
        i.angle {
          color: #000;
          font-size: 38px;
        }
        label {
          padding: 0 3px;
          margin-bottom: 0;
          cursor: pointer;
        }
        span {
          /*color: $app-active-color;*/
          font-size: 16px;
        }
        a.download {
          cursor: pointer;
          i {
            font-size: 20px;
            padding-left: 5px;
          }
        }
      }
    }
    .container {
      width: 100%;
      padding: 0 64px;
    }
    .select2-container {
      width: 100% !important;
    }
  }
  @media screen and (max-width: 600px) {
    .mosaic-view {
      .container {
        padding: 0 24px;
      }
    }
  }
</style>
